
import { computed, defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const EXPRESS_TRACKING_URL = process.env.VUE_APP_EXPRESS_TRACKING_URL

        const trackingUrl = computed(() => {
            return `${EXPRESS_TRACKING_URL}/${props.id}`
        })

        return { trackingUrl }
    },
})
